$(document).ready(function () {
  $('.footer-top-sections .foot-listing:last-child li').each(function() {
    $(this).find('a').attr('target', '_blank').attr('rel', 'noopener');
  });

  $('.custom-tab-head').on('click', function () {
    var target = $(this).data('att');
    var newHeading = $(this).data('heading');

    // Toggle active class
    $('.custom-tab-head').removeClass('active');
    $(this).addClass('active');

    // Show corresponding section
    $('#whysec, #teamsec, #valuesec').hide();
    $('#' + target).show();

    // Update the heading
    $('.tab-heading').text(newHeading);
  });

  // Show the default section and heading (Why section)
  $('#whysec').show();
  var defaultHeading = $('.custom-tab-head[data-att="whysec"]').data('heading');
  $('.tab-heading').text(defaultHeading);

  // Value FAQ
  $('.our-values-row').each(function () {
    const $row = $(this);
    const $content = $row.find('.our-values-accordion-content');
  
    // Initial CSS setup
    $content.css({
      'overflow': 'hidden',
      'transition': 'height 0.4s ease',
      'height': '0px'
    });
  
    $row.on('click', function () {
      const isOpen = $row.hasClass('open');
  
      // Collapse all other rows
      $('.our-values-row.open').not($row).each(function () {
        const $other = $(this);
        const $otherContent = $other.find('.our-values-accordion-content');
  
        $otherContent.css('height', $otherContent[0].scrollHeight + 'px');
        requestAnimationFrame(() => {
          $otherContent.css('height', '0px');
          $other.removeClass('open');
        });
      });
  
      if (isOpen) {
        // Close current
        $content.css('height', $content[0].scrollHeight + 'px');
        requestAnimationFrame(() => {
          $content.css('height', '0px');
          $row.removeClass('open');
        });
      } else {
        // Open current: reset height to 0 first to enable transition
        $content.css('height', '0px');
  
        requestAnimationFrame(() => {
          $row.addClass('open');
          $content.css('height', $content[0].scrollHeight + 'px');
        });
      }
    });
  
    // After expand finishes, set height to auto
    $content.on('transitionend', function () {
      if ($row.hasClass('open')) {
        $content.css('height', 'auto');
      }
    });
  });

  $('.why-us-slider-row').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    prevArrow: '<button class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0815/0027/5023/files/chevron-left.svg?v=1749529064" alt=""></button>',
    nextArrow: '<button class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0815/0027/5023/files/chevron-right.svg?v=1749529064" alt=""></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.accessories-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    prevArrow: '<button class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/0815/0027/5023/files/chevron-left.svg?v=1749529064" alt=""></button>',
    nextArrow: '<button class="custom-next"><img src="https://cdn.shopify.com/s/files/1/0815/0027/5023/files/chevron-right.svg?v=1749529064" alt=""></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });

  var itemsPerClick = 2;
  $('#loadMoreJobs').on('click', function () {
    var hiddenItems = $('.listing-row-outer.hidden-job');
    hiddenItems.slice(0, itemsPerClick).slideDown().removeClass('hidden-job');

    if ($('.listing-row-outer.hidden-job').length === 0) {
      $('#loadMoreJobs').hide();
    }
  });

  function filterByModel() {
    const selectedModel = $('.bicycle-model-box select').val()?.trim().toLowerCase() || '';
    const $activeTab = $('.tab-pane.active');
    const $parentItems = $activeTab.find('.parent-ac');
    let visibleCount = 0;
  
    $parentItems.each(function () {
      const model = ($(this).data('model') || '').toString().trim().toLowerCase();
      if (selectedModel === '' || model === selectedModel) {
        $(this).css('display', 'flex'); // or 'block'
        visibleCount++;
      } else {
        $(this).hide();
      }
    });

    const $noDataMsg = $activeTab.find('.no-data-msg');
    if (visibleCount === 0) {
      $noDataMsg.show();
    } else {
      $noDataMsg.hide();
    }
  }

  // 🔁 1. Filter when dropdown changes
  $('.bicycle-model-box select').on('change', function () {
    filterByModel();
  });

  // 🔁 2. Filter when tab is clicked (custom tab navigation)
  $('.anleitungen-tab-btns .nav-link').on('click', function (e) {
    e.preventDefault();
  
    // Handle tab active class switching
    $('.anleitungen-tab-btns .nav-link').removeClass('active show');
    $(this).addClass('active show');
  
    $('.anleitungen-row  .tab-pane').removeClass('active show');
    const target = $(this).attr('href');
    $(target).addClass('active show');
  
    // Re-run filter on the newly shown tab
    filterByModel();
  });

  // Loading
  window.addEventListener("load", function () {
    const preloader = document.getElementById("preloader");
    preloader.style.display = "none";
  });

  setTimeout(function () {
    console.log('✅ Script started');

    // This binds the change event immediately and works on future inputs too
    $(document).on('change', 'input[type="file"].line-input', function () {
      const $input = $(this);
      injectFileInfo($input);
    });

    function injectFileInfo($input) {
      const files = $input[0].files;
      const $dropzone = $input.closest('.gfb__dropzone');
      const $items = $dropzone.find('.gfb__dropzone--preview--item');

      $items.each(function (index) {
        const $item = $(this);
        const file = files[index];
        if (!file) return;

        const $title = $item.find('.gfb__dropzone--preview--item-title');

        if ($title.find('.custom-file-info').length === 0) {
          const fileExt = file.name.split('.').pop().toUpperCase();
          const fileSizeKB = (file.size / 1024).toFixed(2);
          const nameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
  
          $title.append(`
            <div class="custom-file-info">
              <div class="file-img">${fileExt}</div>
              <div class="file-info">
                <span>${nameWithoutExt}</span>
                <span>${fileSizeKB} KB</span>
              </div>
            </div>
          `);

          console.log('✅ Injected info for:', file.name);
        }
      });
    }

    // Watch for DOM changes inside Globo file dropzone preview area
    const observer = new MutationObserver(() => {
      $('input[type="file"].line-input').each(function () {
        const $input = $(this);
        if ($input[0].files.length) {
          injectFileInfo($input);
        }
      });
    });

    $('.gfb__dropzone--preview--area').each(function () {
      observer.observe(this, { childList: true, subtree: true });
    });

    console.log('✅ Observer and change event ready');
    $('.custom-file-upload-real').each(function () {
      const $form = $(this);
    
      const $placeholder = $form.find('.gfb__dropzone--placeholder');
      const $description = $placeholder.find('.gfb__dropzone--placeholder--description');
      const $button = $placeholder.find('.gfb__dropzone--placeholder--button');
    
      const descriptionText = $description.text().trim();
    
      // Find or create span inside the button
      let $span = $button.find('span');
    
      if (!$span.length) {
        $span = $('<span></span>').appendTo($button);
      }
    
      if (descriptionText && !$span.hasClass('description-appended')) {
        $span.append('' + descriptionText);
        $span.addClass('description-appended'); // prevent duplicate append
      }
    });
  }, 5000);

  if ($('.cross-sell-item .item').length === 0) {
    $('.custom-cart-bottom .draw-cross-heading').hide();
  }  

  function updateCategoryStyles() {
    $('.cst-category-item').each(function () {
      const checkbox = $(this).find('.omgCookie-input-switch');
      const categoryName = $(this).find('.cst-category-name');
  
      if (checkbox.is(':checked')) {
        categoryName.addClass('is-checked');
      } else {
        categoryName.removeClass('is-checked');
      }
    });
  }

  // Initial run
  updateCategoryStyles();

  // On checkbox change
  $('.omgCookie-input-switch').on('change', function () {
    updateCategoryStyles();
  });

  const topCollectionButton = $('.top-collections .gf-option-box li button');

  // Add class to the first top collection menu element on load
  topCollectionButton.first().addClass('custom-active');

  // Handle click using event delegation
  topCollectionButton.on('click', function() {
    topCollectionButton.removeClass('custom-active');
    $(this).addClass('custom-active');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Wait until OneTrust or the banner finishes loading
  setTimeout(function () {
    const cookieCategories = ["preferences", "marketing", "analytics"];

    cookieCategories.forEach(id => {
      const checkbox = document.getElementById(`switch-omgCookie-${id}`);
      if (checkbox && !checkbox.checked) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change"));
      }
    });
  }, 1500); // delay to ensure OneTrust/other app finishes loading
});
